<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="700"
      size="small"
      resizable
      :seq-config="{
        startIndex: (page.curPage - 1) * page.pageSize,
      }"
      row-id="fabricCode"
      :checkbox-config="{ highlight: true, reserve: true }"
      @cell-click="onCellClick"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
    >
      <template v-slot:pager>
        <pagination
          size="small"
          align="right"
          :current-page="page.curPage"
          :page-size="page.pageSize"
          :page-total="page.pageTotal"
          @change="handlePaginationChange"
        />
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              {{ $l('choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:displayImage="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width: 100px; height: 66px"
          fit="cover"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>

      <template v-slot:displayFabricName="{ row }">
        <TableLabel :value="row.fabricName" />
        <TableLabel :value="row.fabricNameEn" />
        <TableLabel label="NO" :value="row.fabricNo" />
      </template>
      <template v-slot:fabricStatus="{ row }">
        <div style="display: flex;">
          <el-tag
            class="mr-2"
            size="mini"
            :type="
              row.fabricStatus === 'Y'
                ? 'success'
                : row.fabricStatus === 'Q'
                ? 'primary'
                : 'danger'
            "
          >
            {{ row.v_fabricStatus }}
          </el-tag>
          <el-tag
            v-if="row.approvalStatus && row.approvalStatus !== 'Y'"
            size="mini"
            effect="plain"
            :type="
              row.approvalStatus === 'Y'
                ? 'success'
                : row.approvalStatus === 'P'
                ? 'primary'
                : 'danger'
            "
          >
            {{ row.v_approvalStatus }}
          </el-tag>
        </div>
        <el-link
          v-if="row.rejectReason && row.approvalStatus === 'R'"
          type="danger"
          :underline="false"
          style="font-size: 13px;"
          @click="showRejectReason(row)"
        >
          {{ $l('btn_showRejectReason') || '查看驳回原因' }}
        </el-link>
      </template>

      <template v-slot:displayWid="{ row }">
        <TableLabel
          :label="$l('table_label_wid') || '门幅'"
          :value="`${row.wid || 0} ${row.widUnit}`"
        />
        <TableLabel
          :label="$l('table_label_fabricWeight') || '克重'"
          :value="`${row.fabricWeight || 0} ${row.fabricWeightUnit}`"
        />
      </template>
      <template v-slot:displayFabricContent="{ row }">
        <TableLabel :value="row.fabricContent" />
        <TableLabel :value="row.fabricContentEn" />
      </template>

      <template v-slot:displayPrice="{ row }">
        <span>
          {{ row.unitPrice }} {{ $l('table_label_unitPriceUnit') || '元' }}/
          {{ row.v_fabricUnit }}
        </span>
      </template>

      <template v-slot:displayCreate="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:displayModify="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
      <template v-slot:toolbar_form>
        <slot name="header">
          <Header
            ref="header"
            :addFabric="addFabric"
            @query="getData"
            @reset="resetPage"
            @resetChecked="resetChecked"
            @informationReview="informationReview"
            :checkedCount="checkedCount"
            @chooseFabricVisible="
              () => {
                chooseFabricVisible = true
              }
            "
            @handleCommand="
              handleCommand({
                opt: { menuType: 'add' },
                data: { fabricCode: '' },
              })
            "
            @remove="remove()"
          >
          </Header>
        </slot>
      </template>
    </vxe-grid>

    <ChooseFabric
      :visible.sync="chooseFabricVisible"
      v-show="fabricSeriesCode != ''"
      url="/digitalCenter/masterFabric/ecomChoose"
      multiple
      confirm-on-close
      reserve
      @confirm="chooseFabricConfirm"
      :extraData="{
        fabricOwner: 'ecomAmazon',
        unboundSeries: 'Y',
        fabricStatusList: ['Q', 'Y'],
      }"
    />

    <AddFabric
      :visible.sync="fabricOption.addFabricVisible"
      confirm-on-close
      reserve
      :fabricSeriesCode="fabricSeriesCode"
      :fabricCode="fabricOption.fabricCode"
      :fabricDisabled="fabricOption.fabricDisabled"
      :isCopy="fabricOption.isCopy"
      :title="fabricOption.title"
      :form="form"
      @close="headerQuery"
    />
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import BaseTable from '@/mixins/base-table'
import AddFabric from '../add-fabric'
import Header from './header.vue'
import tableOpts from './table-opts'
import TableLabel from './label.vue'
import ChooseFabric from '@/views/ecom/components/choose-fabric'
export default {
  mixins: [EditLoading, BaseTable],
  components: {
    ChooseFabric,
    AddFabric,
    Header,
    TableLabel,
  },
  props: {
    fabricSeriesCode: { type: String, default: '' },
    addFabric: { type: Boolean, default: false },
    form: { type: Object, default: () => {} },
  },
  data() {
    return {
      usePage: true,
      loading: false,
      checkedCount: 0,

      fabricOption: {
        fabricCode: '',
        addFabricVisible: false,
        isCopy: false,
        title: '',
        fabricDisabled: false,
      },
      checkedRow: [],
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        // refresh: { query: () =>  this.$refs.header.query() },
      },
      tableColumns: tableColumns(this),
      chooseFabricVisible: false,
      uploadTechOpts: { visible: false, listFabricCode: [] },
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .masterFabricSeriesList({
          fabricSeriesCode: this.fabricSeriesCode,
          ...this.page,
          ...form,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },

    resetChecked() {
      this.$refs.vxeGrid.clearCheckboxRow()
      this.$refs.vxeGrid.clearCheckboxReserve()
      this.checkedCount = 0
      this.checkedRow = []
    },
    handleCommand({ opt, data }) {
      const { menuType } = opt
      if (!menuType) return
      const { fabricCode } = data
      const types = {
        edit: this.$l('dialog_title_edit_fabric') || '编辑面料',
        add: this.$l('dialog_title_Add_fabric') || '新增面料',
        detail: this.$l('dialog_title_fabric_detail') || '面料详情',
        copy: this.$l('dialog_title_copy_fabric') || '复制面料',
      }
      switch (menuType) {
        case 'detail':
        case 'edit':
        case 'add':
        case 'copy':
          this.fabricOption = {
            fabricCode: fabricCode,
            addFabricVisible: true,
            title: types[menuType],
            fabricDisabled: menuType === 'detail',
            isCopy: menuType === 'copy',
          }
          break
        case 'del':
          this.del({ fabricCode })
          break
        case 'submit':
          this.informationReviewApi({ fabricCode })
          break
      }
    },
    del({ fabricCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        },
      ).then(async () => {
        const res = await this.$api
          .masterFabricEcomDel({ fabricCode })
          .catch(() => null)
        const { status } = res || {}
        if (status !== 200) {
          this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
          type: 'success',
        })
        this.$refs.header.query()
        this.resetChecked()
      })
    },

    informationReview() {},

    async informationReviewApi({ fabricCode }) {
      const confirm = await this.$confirm(
        '是否要提交审核该记录？',
        this.$l('label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('btn_cancel') || '取消',
          type: 'warning',
        },
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .masterFabricSubmit({ fabricCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error('申请失败！')
        return
      }
      this.$message({
        showClose: true,
        message: '申请成功！',
        type: 'success',
      })
      this.reload()
    },

    remove() {
      if (!this.checkedRow || !this.checkedRow.length) {
        this.$message({
          message: '请选择需要移除的面料',
          type: 'warning',
        })
        return
      }

      this.$confirm(
        '是否要移除所选面料？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        },
      ).then(async () => {
        this.loadingOpen()
        const listCode = this.checkedRow.map((item) => item.fabricCode)
        const res = await this.$api
          .masterFabricSeriesRemoveFabric({
            fabricSeriesCode: this.fabricSeriesCode,
            listFabricCode: listCode,
          })
          .catch(() => null)
        this.loadingClose()
        const { status } = res || {}
        if (status !== 200) {
          this.$message.error('移除失败！')
          return
        }
        this.$message({
          showClose: true,
          message: '移除成功！',
          type: 'success',
        })
        this.$refs.header.query()
        this.resetChecked()
      })
    },
    chooseFabricConfirm(data) {
      const listCode = data.map((item) => {
        return item.fabricCode
      })
      this.loadingOpen()
      this.$api
        .masterFabricSeriesBindFabric({
          fabricSeriesCode: this.fabricSeriesCode,
          listFabricCode: listCode,
        })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })

          this.$refs.header.query()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    onCheckboxChange({ records, reserves }) {
      this.checkedRow = records.concat(reserves)
      this.checkedCount = !this.checkedRow ? 0 : this.checkedRow.length
    },
    onCellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'col-opt', 'fabricStatus']
      if (filterColumns.includes(property)) return
      this.$refs.vxeGrid.toggleCheckboxRow(row)
      const data = this.$refs.vxeGrid.getCheckboxRecords(true) || []
      const reserves = this.$refs.vxeGrid.getCheckboxReserveRecords(true) || []
      this.checkedRow = data.concat(reserves)
      this.checkedCount = !this.checkedRow ? 0 : this.checkedRow.length
    },
    headerQuery() {
      this.$refs.header.query()
    },
    showRejectReason({ rejectReason }) {
      this.$alert(
        rejectReason,
        this.$l('INDEX.alert_title_rejectReason') || '驳回原因',
        {
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonText: this.$l('INDEX.btn_cancel') || '关闭',
        },
      )
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .vxe-table--main-wrapper {
  margin-top: 0px;
}
::v-deep {
  .el-tag--confirm {
    background-color: #f9f0ff !important;
    border-color: #d3adf7 !important;
    color: #732ed1 !important;
  }
}
</style>
